import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { Pagination } from '../../features/Pagination';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const Documents = () => {
  const [documents, setDocuments] = useState({ items: [], totalCount: 0 });
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const getData = async (count = 20, offset = 0) => {
    try {
      setLoading(true);
      const response = await apiRequests.documents.get(searchValue, count, offset);
      setDocuments(response);
    } catch (e) {
      console.error('Ошибка загрузки документов:', e);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    getData();
  };

  const handleDelete = (id) => {
    apiRequests.documents.delete(id).then(() =>
      setDocuments((prev) => ({
        totalCount: prev.totalCount - 1,
        items: prev.items.filter((i) => i.id !== id),
      })),
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('ru-RU');
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск по номеру или имени клиента..."
        createLink={`${location.pathname}/create`}
      />

      <div className="mb-3">
        {loading ? (
          <p className="text-center">Загрузка...</p>
        ) : documents.items?.length === 0 ? (
          <p className="text-center">По вашему запросу ничего не найдено</p>
        ) : (
          documents.items?.map((doc) => (
            <EntityCard
              key={doc.id}
              title={`Договор №${doc.number}${doc.companyName ? ` - ${doc.companyName}` : ''}`}
              fields={[
                { label: 'Клиент', value: doc.customerName },
                { label: 'Дата', value: formatDate(doc.date) },
              ]}
              editLink={`${location.pathname}/${doc.id}`}
              onDelete={() => handleDelete(doc.id)}
            />
          ))
        )}
      </div>

      {documents.totalCount > 20 && (
        <Pagination
          count={documents.totalCount}
          itemsPerPage={20}
          onChange={(page) => getData(20, 20 * page)}
        />
      )}
    </>
  );
};

export default Documents;
